import get from './get';
import update from './update';
import store from './store';

export default {
    get,
    update,
    store
};


// WEBPACK FOOTER //
// ./src/app/services/default-template/index.js